import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useLoadingStore } from '@stores/LoadingStore.js'

export const useBNStore = defineStore('bnstore', () => {
  // Store Models
  const use_bn          = ref(false)
  const renew_bn        = ref(false)
  const three_years     = ref(false)
  const birth_country   = ref("Australia")
  const birth_state     = ref("")
  const birth_city      = ref("")
  const do_gst          = ref(false)
  const checkName       = ref("")
  // The name the verdict in `responsemessage` is about. `checkName` is the input
  // and keeps moving as they type; anything reacting to the verdict needs the
  // name that was actually checked.
  const checkedName     = ref("")
  const responsemessage = ref("")
  const loadingStore    = useLoadingStore()

  const onSubmit = () => {
    const values = {
      name: checkName.value,
    }

    checkedName.value = values.name

    loadingStore.setLoading(true)
    axios.post('/api/bn/name-check', values)
      .then(response => {
        if (response.status  >= 200 && response.status <= 299){
          responsemessage.value = response.data
        } else {
          Swal.fire(
            'There has been an error',
            'An unexpected error has occurred. Please try again later or contact our support team for assistance.',
            'error',
          )
        }
      })
      .catch(error => {
        const status = error?.response?.status
        if (!status) {
          // No response at all (offline, VPN, blocker): not a verdict, so never enable Register.
          responsemessage.value = { code: 0, unreachable: true }
        } else if(status >= 500 && status <= 599) {
          responsemessage.value = { code: 1 };
        } else if(status === 422) {
          responsemessage.value = {
            code:422,
            shortDescription: error.response.data?.message
          }
        } else {
          // e.g. 429: clear the previous name's verdict so it cannot unlock Register.
          responsemessage.value = { code: 0 }
        }
      })
      .finally(() => {
        loadingStore.setLoading(false)
      })
  }

  const resetData = () => {
    use_bn.value          = false
    renew_bn.value        = false
    three_years.value     = false
    birth_country.value   = 'Australia'
    birth_state.value     = ''
    birth_city.value      = ''
    do_gst.value          = false
    checkName.value       = ''
    checkedName.value     = ''
    responsemessage.value = ''
  }

  const update = (order) => {
    use_bn.value          = !!order.business_name?.use_bn
    renew_bn.value        = !!order.business_name?.renew_bn
    three_years.value     = !!order.business_name?.three_years
    birth_country.value   = order.business_name?.birth_country ?? order.birth_country ?? 'Australia'
    birth_state.value     = order.business_name?.birth_state ?? order.birth_state ?? ''
    birth_city.value      = order.business_name?.birth_city ?? order.birth_city ?? ''
    do_gst.value          = !!order.gst
    checkName.value       = order.business_name?.name ?? ''
  }

  return {
    onSubmit,
    birth_city,
    birth_country,
    birth_state,
    checkName,
    checkedName,
    do_gst,
    renew_bn,
    resetData,
    responsemessage,
    three_years,
    update,
    use_bn,
  }
},  { persist: true, })
